var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cons",staticClass:"home"},[_c('head-nav'),_c('div',{staticClass:"left-fixed-right-auto"},[_c('left-menu'),_c('div',{staticClass:"content_page",style:({'margin-left':_vm.$store.state.menu.sidebar.width,
        'width':_vm.win_size.width+'px',
        })},[_c('bread'),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"z-fade"}},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }